import { useIsEscalated } from 'components/IAP/hooks/incidentHooks';
import { useGetRosterForIncident } from 'hooks/incident/useRoster';
import { useUserPositions } from 'hooks/incident/useUserPosition';
import { NULL_VALUE } from 'constants/displayConstants';
import { usePositionWorkspacesFlag } from 'utils/featureFlags';

import { activeSeats, landingForPositions } from './seatCatalog';

export function staffedPositionNames(
  roster: { incidentPositions: { positionName: string }[] }[] | undefined
): Set<string> {
  const names = new Set<string>();
  for (const member of roster ?? []) {
    for (const position of member.incidentPositions) {
      names.add(position.positionName);
    }
  }
  return names;
}

export function useActiveSeatNav() {
  const workspacesOn = usePositionWorkspacesFlag();
  const escalated = useIsEscalated();
  const positions = useUserPositions();
  const roster = useGetRosterForIncident();
  if (!workspacesOn) {
    return {
      seats: [],
      held: { kind: 'dashboard' as const },
      rosterLoading: false,
    };
  }
  const staffed = staffedPositionNames(roster.data);
  const options = { escalated, staffedPositionNames: staffed };
  const seats = activeSeats(options);
  const held = landingForPositions(
    positions.filter((name) => name && name !== NULL_VALUE),
    options
  );
  return { seats, held, rosterLoading: roster.isLoading };
}
